import Services from 'services';

class AnalisaBarangJadi {
  getSingle(params) {
    return Services.get('/analisa_barang_jadi_rae/single', { params });
  }

  getAnalisaSingle(params) {
    return Services.get('/rae/analisa_single/', { params });
  }

  getAnalisaPeluangSingle(params) {
    return Services.get('/rae/analisa_peluang_single', { params });
  }

  getKayu(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_kayu', { params });
  }

  getKelompokTipeBarangJadi(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_kelompok_tipe', {
      params,
    });
  }

  getTipeBarangJadi(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_tipe', { params });
  }

  getDropdownTipeBarangJadi(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_tipe', { params });
  }

  getSingleTipeBarangJadi(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_tipe', { params });
  }

  getSingleTemplatePenunjang(params) {
    return Services.get('/analisa_barang_jadi_rae/list_template', { params });
  }

  getFinishingBarangJadi(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_finishing', {
      params,
    });
  }

  getDropdownFinishingBarangJadi(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_finishing', {
      params,
    });
  }

  getSingleFinishingBarangJadi(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_finishing', {
      params,
    });
  }

  getDropdownDeskripsi() {
    return Services.get('/analisa_barang_jadi_rae/d_deskripsi');
  }

  getDropdownPartKayu() {
    return Services.get('/analisa_barang_jadi_rae/d_part_kayu');
  }

  getDropdownTipeSisi() {
    return Services.get('/analisa_barang_jadi_rae/d_tipe_sisi');
  }

  getDropdownTipeFinishing() {
    return Services.get('/analisa_barang_jadi_rae/d_finishing');
  }

  getDropdownSpekKayu() {
    return Services.get('/analisa_barang_jadi_rae/d_jenis_kayu');
  }

  getDropdownSpekPlywood() {
    return Services.get('/analisa_barang_jadi_rae/d_plywood');
  }

  getHargaKubikasiKayu(params) {
    return Services.get('/analisa_barang_jadi_rae/harga_kubikasi', { params });
  }

  getDropdownTipeProduksi(params) {
    return Services.get('/analisa_barang_jadi_rae/d_tipe_produksi', { params });
  }

  getDropdownBentuk(params) {
    return Services.get('/analisa_barang_jadi_rae/d_bentuk', { params });
  }

  getDropdownUkuran(params) {
    return Services.get('/analisa_barang_jadi_rae/d_ukuran', { params });
  }

  getDropdownItemLabourCost(params) {
    return Services.get('/buaso/dropdown_upah', { params });
  }

  getKelompokPrelim(params) {
    return Services.get('/analisa_barang_jadi_rae/list_kelompok_prelim', {
      params,
    });
  }

  getItemPrelim(params) {
    return Services.get('/analisa_barang_jadi_rae/dropdown_item_prelim', {
      params,
    });
  }

  getTemplateLabourCost(params) {
    return Services.get('/rae/template_labour_cost_on_site', { params });
  }

  save(data) {
    return Services.post('/analisa_barang_jadi_rae', data);
  }

  uploadFile(data) {
    return Services.post('/analisa_barang_jadi_rae/gambar', data);
  }

  deleteFile(data) {
    return Services.post('/analisa_barang_jadi_rae/gambar_delete', data);
  }
}

export default new AnalisaBarangJadi();
